const r = {
  data() {
    return {
      dropdownKeys_pointer: -1,
      dropdownKeys_optionsModel: []
    };
  },
  watch: {
    active(o) {
      o && this.dropdownKeys_resetPointer();
    }
  },
  methods: {
    dropdownKeys_adjustScroll() {
      const o = this.dropdownKeys_pixelsToPointerTop(), s = this.dropdownKeys_pixelsToPointerBottom(), {
        scrollTop: e,
        offsetHeight: d,
        scrollHeight: n
      } = this.dropdownKeys_getDropdownMenu(), t = this.dropdownKeys_optionsModel[0] && this.dropdownKeys_optionsModel[0].isLabel;
      this.dropdownKeys_pointer === 0 || this.dropdownKeys_pointer === 1 && t ? this.dropdownKeys_scrollTo(0) : this.dropdownKeys_pointer === this.dropdownKeys_optionsModel.length - 1 ? this.dropdownKeys_scrollTo(n) : o <= e ? this.dropdownKeys_scrollTo(o) : s >= d + e && this.dropdownKeys_scrollTo(e + this.dropdownKeys_pointerHeight());
    },
    dropdownKeys_isAllLabelsOnly() {
      return Array.isArray(this.dropdownKeys_optionsModel) && this.dropdownKeys_optionsModel.every((o) => o.isLabel);
    },
    dropdownKeys_arrowDown() {
      this.dropdownKeys_pointer < this.dropdownKeys_optionsModel.length - 1 ? (this.dropdownKeys_pointer++, this.dropdownKeys_adjustScroll()) : this.dropdownKeys_pointer = this.dropdownKeys_optionsModel.length - 1, this.dropdownKeys_optionsModel[this.dropdownKeys_pointer] && this.dropdownKeys_optionsModel[this.dropdownKeys_pointer].isLabel && !this.dropdownKeys_isAllLabelsOnly() && this.dropdownKeys_arrowDown();
    },
    dropdownKeys_arrowUp() {
      this.dropdownKeys_pointer > 0 ? (this.dropdownKeys_pointer--, this.dropdownKeys_adjustScroll(), this.dropdownKeys_optionsModel[this.dropdownKeys_pointer].isLabel && this.dropdownKeys_arrowUp()) : this.dropdownKeys_optionsModel[this.dropdownKeys_pointer] && this.dropdownKeys_optionsModel[this.dropdownKeys_pointer].isLabel ? this.dropdownKeys_arrowDown() : this.dropdownKeys_pointer = 0;
    },
    dropdownKeys_enter() {
      if (this.dropdownKeys_optionsModel[this.dropdownKeys_pointer]) {
        const o = this.dropdownKeys_optionsModel[this.dropdownKeys_pointer];
        this.onEnter && this.onEnter(o);
      }
    },
    dropdownKeys_getDropdownMenu() {
      return this.dropdownMenuSelector ? this.$el.querySelector(this.dropdownMenuSelector) : this.$el.querySelector(".dropdown-menu");
    },
    dropdownKeys_getDropdownMenuListItems() {
      return this.dropdownKeys_getDropdownMenu().querySelectorAll("li");
    },
    dropdownKeys_getListItemHeight(o) {
      if (!o || !o.nodeType)
        return 0;
      let s = o ? o.offsetHeight : 0;
      const e = window.getComputedStyle(o);
      return s += parseInt(e.marginBottom, 10) + parseInt(e.marginTop, 10), s;
    },
    dropdownKeys_pixelsToPointerTop() {
      let o = 0;
      const e = this.dropdownKeys_getDropdownMenu().querySelector(".dropdown-header"), d = this.dropdownKeys_getDropdownMenuListItems(), n = e ? 1 : 0;
      for (let t = n; t < this.dropdownKeys_pointer + n; t++)
        o += this.dropdownKeys_getListItemHeight(d[t]);
      return e && (o += this.dropdownKeys_getListItemHeight(e)), o;
    },
    dropdownKeys_pixelsToPointerBottom() {
      return this.dropdownKeys_pixelsToPointerTop() + this.dropdownKeys_pointerHeight();
    },
    dropdownKeys_pointerHeight() {
      const o = this.dropdownKeys_getDropdownMenuListItems()[this.dropdownKeys_pointer];
      return o ? this.dropdownKeys_getListItemHeight(o) : 0;
    },
    dropdownKeys_resetPointer() {
      if (this.dropdownKeys_pointer = -1, this.dropdownKeys_arrowDown(), this.selected) {
        const o = this.dropdownKeys_getDropdownMenuListItems();
        let s = -1;
        for (let e = 0; e < o.length; e++)
          if (o[e].classList.contains("selected")) {
            s = e;
            break;
          }
        s && (this.allowAdd && (s -= 1), this.showBlank && (s -= 1), this.dropdownKeys_pointer = s);
      }
    },
    dropdownKeys_scrollTo(o) {
      this.dropdownKeys_getDropdownMenu().scrollTop = o;
    }
  }
};
export {
  r as default
};
//# sourceMappingURL=design-system.es299.js.map
